export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6369.5293bf85.jpg";